<div class="dynamic-container">
  <h3>Monster Badge</h3>
  <p>Clicar no Badge vai copiar para o clipboard o span pronto</p>
  <div class="list">
    @for (variant of badgeVariants; track variant) { @for (size of badgeSizes; track size) {
    <div>
      <span class="monster__badge {{ size }} {{ variant }}" (click)="copyToClipboard(size, variant)">Label</span>
    </div>
    } }
  </div>
</div>
